import { DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoService } from '@jsverse/transloco';
import { Subscription, take } from 'rxjs';
import { LocaleService } from 'vcp-common-ui-lib';
import { CoreConstant } from '../constant/base.constant';
import { Language } from '../model/user/language.enum';

export function applyPortalLanguage(lang: Language, transloco: TranslocoService, localeService: LocaleService): void {
    localStorage.setItem(CoreConstant.VC_LANGUAGE_ABBREVIATION, `${lang}`);
    document.documentElement.lang = lang;
    localeService.changeLocale(lang);
    // Set active language before async load so newly created route components resolve
    // translate() and TranslocoPipe with the selected locale (load may still be in flight).
    transloco.setActiveLang(lang);
    transloco.load(lang).pipe(take(1)).subscribe();
}

/** Re-run work that uses `translate()` when the active locale or loaded catalogs change. */
export function selectTranslate(
    transloco: TranslocoService,
    callback: () => void,
    destroyRef: DestroyRef
): Subscription {
    return transloco
        .selectTranslate('')
        .pipe(takeUntilDestroyed(destroyRef))
        .subscribe(() => callback());
}
